/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';

import Loading from 'components/Loading/Loading';
import ActionDrawerHeader from 'views/ActionDrawer/components/ActionDrawerHeader/ActionDrawerHeader';

import MarkAsDefaultLocationSuccess from './MarkAsDefaultLocationSuccess/MarkAsDefaultLocationSuccess';
import MarkAsDefaultLocationError from './MarkAsDefaultLocationError/MarkAsDefaultLocationError';

import styles from '../../../ActionDrawer.module.scss';
import { ComponentWithInjectedProps } from 'utils/injectedProps';

type TypeProps = {|
  location: Object,
|};

type InjectedProps = {
  actionDrawerStore: TypeActionDrawerStore,
} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class MarkAsDefaultLocation extends ComponentWithInjectedProps<
  TypeProps,
  {},
  InjectedProps
> {
  componentDidMount() {
    const { actionDrawerStore, location } = this.props;

    actionDrawerStore.markAsDefaultLocation(location);
  }

  render(): React.Element<*> {
    const { t, actionDrawerStore, location } = this.props;

    const title: string = t('general:locations.mark_as_default_location');

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={title} />
          <MarkAsDefaultLocationError location={location} />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.success}`}>
          <ActionDrawerHeader title={title} />
          <MarkAsDefaultLocationSuccess response={actionDrawerStore.response} />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={t('general:locations.mark_as_default_location')} />
      </div>
    );
  }
}
